import './filter-block.scss';

export default () => {

};
